import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../context/AuthContext";
import TherapyRoomCard from "../TherapyRooms/TherapyRoomCard";
import Navbar from "../Navbar";
import Footer from "../Footer";
import beach from "../../assets/images/beach.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Env from '../../runtimeEnv';


function DemoPage({
  
}) {
  const navigate = useNavigate();
  const [sessions, setSessions] = useState([]);
  const {
      currentNickname,
      setCurrentNickname,
      handleLogout,
      PlutonicuserID,
      userType,
      currentFormType,
      setCurrentFormType,
    } = useContext(AuthContext);
      let firstSession;



  // useEffect(() => {
  //   const userId = PlutonicuserID || localStorage.getItem("PlutonicuserID");

  //   // console.log("[DemoPage] Current User ID:", userId);

  //   const checkDemoAccess = async () => {
  //     try {
  //       const response = await axios.get(
  //         `${process.env.REACT_APP_PYTHON_API_URL}/api/GetMeetings/${userId}`,
  //         {
  //           headers: {
  //             "Cache-Control": "no-cache",
  //             Pragma: "no-cache",
  //             Expires: "0",
  //           },
  //           params: { t: new Date().getTime() }, // Cache-busting
  //         }
  //       );

  //       const meetings = response.data;

  //       const hasDemoAccessSessions = meetings.filter(
  //         (meeting) =>
  //           meeting.PlutonicuserID.includes(userId) &&
  //           meeting.demoaccess === true
  //       );
        
  //       if (hasDemoAccessSessions.length === 0) {
  //         navigate("/therapy-rooms");
  //       } else {
  //         console.log("✅ User has demo access.");
  //         setSessions(hasDemoAccessSessions); // Save sessions to state
  //       }
        
  //     } catch (error) {
  //       // console.error("[DemoPage] Error fetching meetings:", error);
  //       navigate("/therapy-rooms"); // fallback redirect if there's an error
  //     }
  //   };

  //   if (userId) {
  //     checkDemoAccess();
  //   } else {
  //     // console.warn("[DemoPage] No user ID found. Redirecting.");
  //     navigate("/therapy-rooms");
  //   }
  // }, [PlutonicuserID, navigate]);


  useEffect(() => {
    const userId = PlutonicuserID || localStorage.getItem("PlutonicuserID");
  
    const checkDemoAccess = async () => {
      try {
        const response = await axios.get(
          `${Env.REACT_APP_PYTHON_API_URL}/api/GetMeetings/${userId}`,
          {
            headers: {
              "Cache-Control": "no-cache",
              Pragma: "no-cache",
              Expires: "0",
            },
            params: { t: new Date().getTime() },
          }
        );
  
        const meetings = response.data;
  
        const hasDemoAccessSessions = meetings.filter(
          (meeting) =>
            meeting.PlutonicuserID.includes(userId) && meeting.demoaccess === true
        );
  
        if (hasDemoAccessSessions.length === 0) {
          navigate("/therapy-rooms");
        } else {
          // ✅ Always mark session as available for demo
          const enrichedSessions = hasDemoAccessSessions.map((s) => ({
            ...s,
            isAvailable: true,
          }));
  
          setSessions(enrichedSessions);
        }
      } catch (error) {
        navigate("/therapy-rooms");
      }
    };
  
    if (userId) {
      checkDemoAccess();
    } else {
      navigate("/therapy-rooms");
    }
  }, [PlutonicuserID, navigate]);
  const beachRoom = {
    id: "demo-beach-therapy",
    title: "Plutonic Therapy Beach Office",
    description:
      "Consider having a session with your licensed mental health professional inside the office or in the cabana. Take in the sounds of the ocean waves and the sunset as you reduce stress.",
    image: beach,
    style: "Modern Design",
    accessibility: "PC Web Browser | Chrome, Edge",
    available: true,
    sessionStartTimeEST: "Always Available",
    online: false,
  };

  const handleEnterClick = (roomType) => {
    const userId = PlutonicuserID || localStorage.getItem("PlutonicuserID");
    if (!userId) {
      alert("User ID is missing. Please log in again.");
      return;
    }
  

  
    const testMeetingID = `${roomType}-${userId}`;
    sessionStorage.setItem("meetingID", testMeetingID);
    sessionStorage.setItem("userId", userId);
  
    // console.log("[DemoPage] sessionStorage - meetingID:", testMeetingID);
    // console.log("[DemoPage] sessionStorage - userId:", userId);
  
    navigate(`/unity-room/${roomType}`);
  };
if (sessions.length > 0) {
  firstSession = {
    ...sessions[0],
    isAvailable: true,
    isUpcoming: false,
    isPrimary: true,
  };
}


  return (
    <div>
      <Navbar
        setCurrentNickname={(nickname) => {
          setCurrentNickname(nickname);
          localStorage.setItem("currentNickname", nickname);
        }}
        currentNickname={currentNickname}
        handleLogout={handleLogout}
        setCurrentFormType={setCurrentFormType}
        showButtons={true}
        PlutonicuserID={
          PlutonicuserID || localStorage.getItem("PlutonicuserID")
        }
      />
      <div
        className="flex flex-col items-center min-h-screen pt-24 pb-16 px-12 mx-auto"
        style={{
          background: "linear-gradient(to bottom, #CBCECE, #77D8EE, #CBCECE)",
        }}
      >
        <h2 className="text-3xl font-bold mb-12 self-start pl-4 mt-8">
          Welcome to Your Demo Space
        </h2>
        <div className="w-full flex justify-center">
  <div className="w-full max-w-md">
    
    <TherapyRoomCard
  key={beachRoom.id}
  room={beachRoom}
  isSelected={false}
  onSelect={() => {}}
  onEnterClick={() => handleEnterClick(beachRoom.id)}
  sessions={firstSession ? [firstSession] : []}
/>

  </div>
</div>

      </div>
      <Footer />
    </div>
  );
}

export default DemoPage;